import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { CacheService } from './cache.service'
import { switchMap } from 'rxjs/operators'
import { of ,  Observable } from 'rxjs'



@Injectable()
export class HttpClientCachingService {

    constructor(
        private http: HttpClient,
        private _cacheService: CacheService,
    ) { }



    post<T>(URL, params): Observable<T> {
        return this.httpCall(URL, params)
    }



    private httpCall<T>(url, params): Observable<T> {

        // Setup default values
        params = params || null
        // Get data from cache
        const data = this._cacheService.load(url)
        // Return data from cache
        if (data !== null) {
            return of<T>(data)
        }


        return this.http.post<any>(url, params)
            .pipe(
                switchMap(response => {
                    // Data will be cached
                    this._cacheService.save({
                        key: url,
                        data: response,
                        expirationMins: 20
                    })
                    return of<any>(response)
                })
            )
    }
}

export class HttpOptions {
    url: string
    body?: any
    cacheMins?: number
}
